import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import styles from './Index.module.css'
import Slider from 'react-slick'
import Card from '../../components/Slider/Card'
import { settings } from '../../constants/settingSlider'
import { authRequestStart } from '../../redux/actions/Auth'
import Modal from '../../components/Modal'
import ErrorBoundary from '../../components/ErrorBoundary'
import { orderStatusRequest } from '../../redux/actions/OrderStatus'

const safeOrders = item => (item && Array.isArray(item.orders) ? item.orders.filter(Boolean) : [])

const mapStateToProps = ({ orderData }) => ({
  orderData: (Array.isArray(orderData) ? orderData : []).filter(item => {
    if (!item) return false
    // Заказ с киоска (оплата по QR) создаётся в POS ещё до подтверждения оплаты:
    // sent и qr_paid бэкенд проставляет одновременно только когда платёж подтверждён.
    // Пока item.sent пуст, заказ ещё не подтверждён — показывать его рано,
    // иначе на секунды/десятки секунд карточка мелькает с неверной пометкой
    // «Оплата официанту» вместо ещё не пришедшего «Оплачено по QR-коду».
    if (!item.sent) return false
    const orders = safeOrders(item)
    const finishedOrders = orders.filter(order => order.finished)

    return finishedOrders.length !== orders.length
  }),
})

const mapDispatchToProps = {
  authRequest: authRequestStart,
  sendStatus: orderStatusRequest,
}

// Меняется, когда список заказов обновился — по нему ErrorBoundary понимает,
// что пришли свежие данные, и можно попробовать отрендерить заново
// (например, после того как новый заказ «дособрался» на бэкенде).
const ordersResetKey = list =>
  list
    .map(item => {
      const orders = safeOrders(item)
      return `${item?.id}:${orders.length}:${orders.filter(o => o.finished).length}:${item?.sent || ''}`
    })
    .join('|')

const IndexScene = ({ orderData, authRequest, sendStatus }) => {
  const [modalData, setModalData] = useState(false)
  const [visibleModal, setVisibleModal] = useState(false)
  const pathname = window.location.pathname?.split('/')[1]

  useEffect(() => {
    if (!!pathname) {
      authRequest(pathname)
    }
  }, [pathname])

  return (
    <div className={styles.card_list}>
       {!!orderData.length ? (
        <ErrorBoundary
          resetKey={ordersResetKey(orderData)}
          fallback={
            <div className={styles.no_found}>
              <h1>Обновление заказов…</h1>
            </div>
          }
        >
        <Slider {...settings}>
          {orderData && orderData.map((item, i) =>
          <Card
            key={i}
            data={item}
            setModalData={setModalData}
            setVisibleModal={setVisibleModal}
            sendRequest={order => console.log(order, 'order')}
            modalData={modalData}
            sendStatus={sendStatus}
            pathname={pathname}
            />)}

        </Slider>
        </ErrorBoundary>
      ) : (
        <div className={styles.no_found}>
          <h1>Нет заказов</h1>
        </div>
      )}
      {false && (
        <Modal
          setVisibleModal={setVisibleModal}
          data={modalData}
          sendRequest={order => {
            if (order === 'all') {
              modalData.arrayIds.forEach(e => sendStatus({ ...modalData, id: e, restid: parseInt(pathname) }))
            } else {
              sendStatus({ ...modalData, restid: parseInt(pathname) })
            }
            setVisibleModal(false)
          }}
        />
      )}
    </div>
  )
}
export default connect(mapStateToProps, mapDispatchToProps)(IndexScene)
